<script>
export default {
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      options: []
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  mounted() {
    this.initOptions();
  },
  methods: {
    initOptions() {
      this.loading = true;
      this.$store.dispatch('bu_cargoClassify/fetchOptions', {}).then(res => {
        this.options = res.data;
      }).finally(() => {
        this.loading = false;
      });
    },
    onChange(val) {
      const checkedItem = this.options.find(item => item.value === val)
      this.$emit('change', checkedItem)
      this.$emit('update:label', checkedItem?.label)
    }
  }
}
</script>

<template>
  <el-select
    v-model="selectedValue"
    :loading="loading"
    v-bind="$attrs"
    @change="onChange"
    filterable
    default-first-option
    clearable
    style="width: 100%;"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<style lang="scss" scoped></style>
